import { action, computed, observable } from 'mobx';
import { ParameterController } from 'cd-eft/services/eftPrjAdminApi';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { WaterwaySizingController } from 'cd-eft/services/eftSetApi';
import stores from '../../../../models/Stores'
import { WaterwaySizingParamsDTO } from "cd-eft/_codegen_/openapi-generator/eft-set"
import { IWscVmProps } from '../WaterwaySizingCalculatorVM';
import { appConfig } from 'cd-eft/config/AppConfig';

const waterwayDesignStore = stores.AppStore.waterwayDesignStore;
const { terraceDesignStore, designStore } = stores.AppStore;

type numberResetString = '' | number | "RESET";

interface IVegetalForm {
  vegetalCoverDropdown: string;
  manualboxOne: string;
  manualboxTwo: numberResetString;
  // methods: '',
  retardanceClassForm: {
    retardanceClassForStability: string;
    retardanceClassForCapacity: string;
  }
  rciForm: {
    rciStability: numberResetString;
    rciCapacity: numberResetString;
  }
  stemLengthDensityForm: {
    stemLengthStabilityLength: numberResetString;
    stemLengthStabilityDensity: numberResetString;
    stemLengthCapacityLength: numberResetString;
    stemLengthCapacityDensity: numberResetString;
    stemStabilityRci: number;
    stemCapacityRci: number;
  }
  manningForm: {
    manningStability: numberResetString;
    manningCapacity: numberResetString;
  }
};
interface IRciMenu {
  A?: string;
  B?: string;
  C?: string;
  D?: string;
  E?: string;
}

export class VegetalCoverVM {

  constructor(props: IWscVmProps) {
    this.mode = props.mode;
  }
  mode: 'design' | 'standalone' | 'adminGlobalPreferences' = 'standalone';

  /* */
  @observable RetardanceClassControl: number = 0; // 0=retClassStr, 1= rci, 2= stemLength, 3= manningsN
  @observable disableVegetalCoverManualInputs: boolean = true;
  @observable retClassStrValue: string = '';
  @observable rciValue: string = '';
  // @observable options: any = [1, 2];
  @observable vegetalCoverOptions: any = [];
  @observable retardanceClassMenu = [];
  @observable rciMenu: IRciMenu = {};
  @observable rciStabilityCalculated = false;
  @observable rciCapacityCalculated = false;

  @observable hasAnyInputChanged = false;

  @observable waterWayWizardStatus: number = 1; // 1: default, 2: success, 3:error

  @observable formValidation = {
    hasError: false,
    vegetalCoverDropdown: true,
    manualboxOne: true,
    manualboxTwo: true,
    retardanceClassForStability: true,
    retardanceClassForCapacity: true,
    rciStability: true,
    rciCapacity: true,
    stemLengthStabilityLength: true,
    stemLengthStabilityDensity: true,
    stemLengthCapacityLength: true,
    stemLengthCapacityDensity: true,
    stemStabilityRci: true,
    stemCapacityRci: true,
    manningStability: true,
    manningCapacity: true,
    formErrors: {
      vegetalCoverDropdown: '',
      manualboxOne: '',
      manualboxTwo: '',
      retardanceClassForm: {
        retardanceClassForStability: '',
        retardanceClassForCapacity: '',
      },
      rciForm: {
        rciStability: '',
        rciCapacity: '',
      },
      stemLengthDensityForm: {
        stemLengthStabilityLength: '',
        stemLengthStabilityDensity: '',
        stemLengthCapacityLength: '',
        stemLengthCapacityDensity: '',
        stemStabilityRCI: '',
        stemCapacityRCI: '',
      },
      manningForm: {
        manningStability: '',
        manningCapacity: '',
      },
    },
  };
  @observable defineVegetalCoverForm: IVegetalForm = {
    vegetalCoverDropdown: '',
    manualboxOne: '',
    manualboxTwo: '',
    // methods: '',
    retardanceClassForm: {
      retardanceClassForStability: '',
      retardanceClassForCapacity: '',
    },
    rciForm: {
      rciStability: '',
      rciCapacity: '',
    },
    stemLengthDensityForm: {
      stemLengthStabilityLength: '',
      stemLengthStabilityDensity: '',
      stemLengthCapacityLength: '',
      stemLengthCapacityDensity: '',
      stemStabilityRci: 0,
      stemCapacityRci: 0,
    },
    manningForm: {
      manningStability: '',
      manningCapacity: '',
    },
  };

  //function to organize data from vegetal cover object(define vegetal cover form)
  get exportVegetalCoverDTO() {
    const resultDTO: WaterwaySizingParamsDTO = {
      vegetalCapacityOption: '',
      vegetalStabilityOption: '',
      vegetalCapacityParams: {},
      vegetalStabilityParams: {},
    }
    if (this.RetardanceClassControl === 0) {
      resultDTO.vegetalCapacityOption = 'Retardance Class';
      resultDTO.vegetalStabilityOption = 'Retardance Class';
    } else if (this.RetardanceClassControl === 1) {
      resultDTO.vegetalCapacityOption = 'Retardance Curve Index';
      resultDTO.vegetalStabilityOption = 'Retardance Curve Index';
    } else if (this.RetardanceClassControl === 2) {
      resultDTO.vegetalCapacityOption = 'Stem length/density';
      resultDTO.vegetalStabilityOption = 'Stem length/density';
    } else if (this.RetardanceClassControl === 3) {
      resultDTO.vegetalCapacityOption = "Manning's n";
      resultDTO.vegetalStabilityOption = "Manning's n";
    }

    if (this.RetardanceClassControl === 0) {
      resultDTO.vegetalCapacityParams!.rci = this.rciMenu[this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity];
      resultDTO.vegetalStabilityParams!.rci = this.rciMenu[this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability];
    }
    else if (this.RetardanceClassControl === 2) {
      resultDTO.vegetalCapacityParams!.rci = +this.defineVegetalCoverForm.stemLengthDensityForm.stemCapacityRci;
      resultDTO.vegetalStabilityParams!.rci = +this.defineVegetalCoverForm.stemLengthDensityForm.stemStabilityRci;
    }
    else {
      resultDTO.vegetalCapacityParams!.rci = (this.defineVegetalCoverForm.rciForm.rciCapacity === '' || this.defineVegetalCoverForm.rciForm.rciCapacity === 'RESET') ? 0 : this.defineVegetalCoverForm.rciForm.rciCapacity;
      resultDTO.vegetalStabilityParams!.rci = (this.defineVegetalCoverForm.rciForm.rciStability === '' || this.defineVegetalCoverForm.rciForm.rciStability === 'RESET') ? 0 : this.defineVegetalCoverForm.rciForm.rciStability;
    }
    resultDTO.vcffactor =
      this.defineVegetalCoverForm.vegetalCoverDropdown.toLocaleLowerCase() === 'manual entry'
        ? +this.defineVegetalCoverForm.manualboxTwo
        : +this.defineVegetalCoverForm.vegetalCoverDropdown.match(/[0-9.]+/)?.[0]!;
    console.log('veg cover: ', this.defineVegetalCoverForm.vegetalCoverDropdown)
    resultDTO.vcDescription = this.defineVegetalCoverForm.vegetalCoverDropdown.toLocaleLowerCase() === 'manual entry'
      ? this.defineVegetalCoverForm.manualboxOne
      : this.defineVegetalCoverForm.vegetalCoverDropdown.split(/(\s\(\d\.?)/)[0];
    resultDTO.vegetalCapacityParams!.manningsN = (this.defineVegetalCoverForm.manningForm.manningCapacity === '' || this.defineVegetalCoverForm.manningForm.manningCapacity === 'RESET') ? 0 : this.defineVegetalCoverForm.manningForm.manningCapacity;
    resultDTO.vegetalStabilityParams!.manningsN = (this.defineVegetalCoverForm.manningForm.manningStability === '' || this.defineVegetalCoverForm.manningForm.manningStability === 'RESET') ? 0 : this.defineVegetalCoverForm.manningForm.manningStability;
    resultDTO.vegetalCapacityParams!.retClassStr = this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity;
    resultDTO.vegetalStabilityParams!.retClassStr = this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability;
    resultDTO.vegetalCapacityParams!.stemDensity = (this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityDensity === '' || this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityDensity === 'RESET') ? 0 : this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityDensity;
    resultDTO.vegetalCapacityParams!.stemLength = (this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityLength === '' || this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityLength === 'RESET') ? 0 : this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityLength;
    resultDTO.vegetalStabilityParams!.stemDensity = (this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityDensity === '' || this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityDensity === 'RESET') ? 0 : this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityDensity;
    resultDTO.vegetalStabilityParams!.stemLength = (this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityLength === '' || this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityLength === 'RESET') ? 0 : this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityLength;

    return resultDTO;
  }

  @computed get silentCheck() {
    // true is incomplete
    let runningTotal = false;
    if (this.defineVegetalCoverForm.vegetalCoverDropdown.toLocaleLowerCase() === 'manual entry') {
      runningTotal = runningTotal || this.formValidation.manualboxOne || this.formValidation.manualboxTwo || this.defineVegetalCoverForm.manualboxOne === '' || this.defineVegetalCoverForm.manualboxTwo === '' || this.defineVegetalCoverForm.manualboxTwo === 'RESET'
    }
    else {
      runningTotal = runningTotal || this.formValidation.vegetalCoverDropdown;
    }
    if (this.RetardanceClassControl === 0) {
      const retardanceClass = this.defineVegetalCoverForm.retardanceClassForm;
      runningTotal = runningTotal || this.formValidation.retardanceClassForStability || this.formValidation.retardanceClassForCapacity || retardanceClass.retardanceClassForStability < retardanceClass.retardanceClassForCapacity;
    }
    else if (this.RetardanceClassControl === 1) {
      runningTotal = runningTotal || this.formValidation.rciStability || this.formValidation.rciCapacity;
    }
    else if (this.RetardanceClassControl === 2) {
      runningTotal = runningTotal ||
        this.formValidation.stemLengthStabilityLength ||
        this.formValidation.stemLengthStabilityDensity ||
        this.formValidation.stemLengthCapacityLength ||
        this.formValidation.stemLengthCapacityDensity ||
        this.defineVegetalCoverForm.stemLengthDensityForm.stemStabilityRci > this.defineVegetalCoverForm.stemLengthDensityForm.stemCapacityRci;
    }
    else if (this.RetardanceClassControl === 3) {
      runningTotal = runningTotal ||
        this.formValidation.manningStability ||
        this.formValidation.manningCapacity

    }
    return runningTotal;
  }

  //function for final validation on selected radio
  @action.bound async fullSelectiveValidation(silentCheck?: boolean) {

    await this.validateInput('vegetalCoverDropdown', this.defineVegetalCoverForm.vegetalCoverDropdown, silentCheck);
    let isvegetalCoverDropdownValid = false;
    if (this.formValidation.vegetalCoverDropdown) {
      isvegetalCoverDropdownValid = true;
    }
    else {
      if (this.defineVegetalCoverForm.vegetalCoverDropdown.toLocaleLowerCase() === 'manual entry') {
        await this.validateInput('manualboxOne', this.defineVegetalCoverForm.manualboxOne, silentCheck);
        await this.validateInput('manualboxTwo', this.defineVegetalCoverForm.manualboxTwo, silentCheck);
      }
      isvegetalCoverDropdownValid = this.formValidation.manualboxOne || this.formValidation.manualboxTwo
    }

    if (this.RetardanceClassControl === 0) {
      const retardanceClass = this.defineVegetalCoverForm.retardanceClassForm;
      await this.validateInput('retardanceClassForStability', retardanceClass.retardanceClassForStability, silentCheck);
      await this.validateInput('retardanceClassForCapacity', retardanceClass.retardanceClassForCapacity, silentCheck);
      return isvegetalCoverDropdownValid || this.formValidation.retardanceClassForCapacity || this.formValidation.retardanceClassForStability
    }
    else if (this.RetardanceClassControl === 1) {
      const rci = this.defineVegetalCoverForm.rciForm;
      await this.validateInput('rciStability', rci.rciStability, silentCheck);
      await this.validateInput('rciCapacity', rci.rciCapacity, silentCheck);
      return isvegetalCoverDropdownValid || this.formValidation.rciCapacity || this.formValidation.rciStability
    }
    else if (this.RetardanceClassControl === 2) {
      const stem = this.defineVegetalCoverForm.stemLengthDensityForm;
      await this.validateInput('stemLengthStabilityLength', stem.stemLengthStabilityLength, silentCheck);
      await this.validateInput('stemLengthStabilityDensity', stem.stemLengthStabilityDensity, silentCheck);
      await this.validateInput('stemLengthCapacityLength', stem.stemLengthCapacityLength, silentCheck);
      await this.validateInput('stemLengthCapacityDensity', stem.stemLengthCapacityDensity, silentCheck);
      await this.validateInput('calculatedStabilityRci', stem.stemStabilityRci, silentCheck);
      await this.validateInput('calculatedCapacityRci', stem.stemCapacityRci, silentCheck);
      return (isvegetalCoverDropdownValid || this.formValidation.stemCapacityRci || this.formValidation.stemStabilityRci
        || this.formValidation.stemLengthCapacityDensity || this.formValidation.stemLengthCapacityLength
        || this.formValidation.stemLengthStabilityDensity || this.formValidation.stemLengthStabilityLength
      )

    }
    else if (this.RetardanceClassControl === 3) {
      const mannings = this.defineVegetalCoverForm.manningForm;
      await this.validateInput('manningStability', mannings.manningStability, silentCheck);
      await this.validateInput('manningCapacity', mannings.manningCapacity, silentCheck);
      return isvegetalCoverDropdownValid || this.formValidation.manningCapacity || this.formValidation.manningStability
    }

  }
  @action.bound setFormErrors() {
    let value = false;
    for (const el in this.formValidation) {
      if (el === 'hasError' || el === 'formErrors') {
        continue;
      }
      if (this.formValidation[el]) {
        if (
          (this.RetardanceClassControl === 0 && el.includes('retardance'))
          || (this.RetardanceClassControl === 1 && el.includes('rci'))
          || (this.RetardanceClassControl === 2 && el.includes('stemLength'))
          || (this.RetardanceClassControl === 3 && el.includes('manning'))
          || el.includes('manual') || el.includes('vegetalCoverDropdown')
        ) {
          value = true;
        }
      }
    }
    if (value) {
      this.formValidation.hasError = true;
    }
  }

  @action.bound vegetalCoverErrorClass() {
    const errorMessage = this.formValidation.formErrors.vegetalCoverDropdown;
    return errorMessage?.length === 0 ? '' : ' usa-input--error';
  }

  @action.bound dropdownErrorClassOne(field) {
    const errorMessage = this.formValidation.formErrors[field];
    if (this.defineVegetalCoverForm.vegetalCoverDropdown.toLocaleLowerCase() !== 'manual entry') {
      this.formValidation.hasError = false;
      this.formValidation.manualboxOne = false;
      this.formValidation.formErrors.manualboxOne = '';
      return 'manualboxOneDisable';
    }
    return errorMessage?.length === 0 ? `${field} ` : `${field} usa-input--error  usa-alert--error`;
  }
  @action.bound dropdownErrorClassTwo(field) {
    const errorMessage = this.formValidation.formErrors[field];
    if (this.defineVegetalCoverForm.vegetalCoverDropdown.toLocaleLowerCase() !== 'manual entry') {
      this.formValidation.hasError = false;
      this.formValidation.manualboxTwo = false;
      this.formValidation.formErrors.manualboxTwo = '';
      return 'manualboxTwoDisable';
    }
    return errorMessage?.length === 0 ? `${field} ` : `${field} usa-input--error  usa-alert--error`;
  }

  @action.bound retardanceErrorClass(field) {
    const errorMessage = this.formValidation.formErrors.retardanceClassForm[field];
    return errorMessage?.length === 0 ? `${field}` : `${field} usa-alert--error usa-input--error`;
  }

  @action.bound rciInputErrorClass(field) {
    const errorMessage = this.formValidation.formErrors.rciForm[field];
    return errorMessage?.length === 0 ? `${field}` : `${field} usa-input--error usa-alert--error`;
  }

  stemInputErrorClass(field) {
    const errorMessage = this.formValidation.formErrors.stemLengthDensityForm[field];
    return errorMessage?.length === 0 ? `${field}` : `${field} usa-input--error usa-alert--error`;
  }
  @action.bound manningInputErrorClass(field) {
    const errorMessage = this.formValidation.formErrors.manningForm[field];
    return errorMessage?.length === 0 ? `${field}` : `${field} usa-input--error usa-alert--error`;
  }

  rciStemInputErrorClass(field) {
    const errorMessage = this.formValidation.formErrors.stemLengthDensityForm[field];
    return errorMessage?.length === 0 || errorMessage?.length === undefined ? `${field} input` : `${field} usa-input--error usa-alert--error `;
  }


  @action.bound selectRetardanceMethod(event) {
    this.hasAnyInputChanged = true;
    const { name } = event.target;
    if (name === 'retClassStr') {
      this.RetardanceClassControl = 0;
    } else if (name === 'rci') {
      this.RetardanceClassControl = 1;
    } else if (name === 'stemLength') {
      this.RetardanceClassControl = 2;
    } else if (name === 'manningsN') {
      this.RetardanceClassControl = 3;
    }
  }

  get retardanceClassControl(): boolean {
    return this.RetardanceClassControl === 0;
  }
  get retardanceCurveControl(): boolean {
    return this.RetardanceClassControl === 1;
  }
  get stemLengthControl(): boolean {
    return this.RetardanceClassControl === 2;
  }
  get manningControl(): boolean {
    return this.RetardanceClassControl === 3;
  }

  @action.bound handleOnKeyDown(event) {
    (["e", "E", "+", "-"].includes(event.key)) && event.preventDefault()
  }

  @action.bound handleInputChange(event) {
    const { name, value } = event.target;
    if (designStore.designElementTypeId === appConfig.hardCodes.designElementTypeTerrace) {
      terraceDesignStore.terraceInputsChanged = true;
      this.hasAnyInputChanged = true;
    }
    switch (name) {
      case 'vegetalCoverDropdown':
        this.defineVegetalCoverForm.vegetalCoverDropdown = value;
        if (String(value).toLocaleLowerCase() === 'manual entry') {
          this.defineVegetalCoverForm.manualboxOne = '';
          this.defineVegetalCoverForm.manualboxTwo = '';
          this.formValidation.manualboxOne = true;
          this.formValidation.manualboxTwo = true;
        }
        break;
      case 'manualboxOne':
        this.defineVegetalCoverForm.manualboxOne = value;
        break;
      case 'manualboxTwo':
        if (value < 0) { this.defineVegetalCoverForm.manualboxTwo = 0 }
        else {
          this.defineVegetalCoverForm.manualboxTwo = parseFloat(value);
        }
        break;
      case 'retardanceClassForStability':
        this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability = value;
        break;
      case 'retardanceClassForCapacity':
        this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity = value;
        break;
      case 'rciStability':
        if (value < 0) { this.defineVegetalCoverForm.rciForm.rciStability = 0 }
        else { this.defineVegetalCoverForm.rciForm.rciStability = parseFloat(value) }
        break;
      case 'rciCapacity':
        if (value < 0) { this.defineVegetalCoverForm.rciForm.rciCapacity = 0 }
        else { this.defineVegetalCoverForm.rciForm.rciCapacity = parseFloat(value) }
        break;
      case 'stemLengthStabilityLength':
        if (value < 0) { this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityLength = 0 }
        else { this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityLength = parseFloat(value) }
        break;
      case 'stemLengthStabilityDensity':
        if (value < 0) { this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityDensity = 0 }
        else { this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityDensity = parseFloat(value) }
        break;
      case 'stemLengthCapacityLength':
        if (value < 0) { this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityLength = 0 }
        else { this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityLength = parseFloat(value) }
        break;
      case 'stemLengthCapacityDensity':
        if (value < 0) { this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityDensity = 0 }
        else { this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityDensity = parseFloat(value) }
        break;
      case 'manningStability':
        if (value < 0) { this.defineVegetalCoverForm.manningForm.manningStability = 0 }
        else { this.defineVegetalCoverForm.manningForm.manningStability = parseFloat(value) }
        break;
      case 'manningCapacity':
        if (value < 0) { this.defineVegetalCoverForm.manningForm.manningCapacity = 0 }
        else { this.defineVegetalCoverForm.manningForm.manningCapacity = parseFloat(value) }
        break;
    }
    if (name === 'retardanceClassForStability' || name === 'retardanceClassForCapacity') {
      this.validateInput(name, value);
    }
  }

  @action.bound setFixedValue(name, fixed) {
    const event1 = {
      target: {
        name: name,
        value: fixed
      }
    }
    this.handleInputChange(event1);
  }

  @action.bound async validateRciDiff(isStability: boolean, silentCheck?: boolean) {
    const stability = this.defineVegetalCoverForm.rciForm.rciStability;
    const capacity = this.defineVegetalCoverForm.rciForm.rciCapacity;
    const bothValidValues = (stability !== '' && capacity !== '' && stability !== 'RESET' && capacity !== 'RESET');
    if (!bothValidValues) return;
    // Both values should be valid for this comparison
    // If either is invalid, that takes priority for the user to fix
    // check if both inputs have valid comparison
    if (stability > capacity) {
      // Set both to be invalid
      this.formValidation.rciStability = true;
      this.formValidation.rciCapacity = true;
      if (!silentCheck) {
        this.formValidation.formErrors.rciForm.rciStability = ' ';
        this.formValidation.formErrors.rciForm.rciCapacity = '  ';
        await MessageCenter.addNotificationFromCode('WDT_13');
      }
      this.formValidation.hasError = true;
    }
    // If neither valid OR both are valid with the right comparison, try to reset the other if valid.
    else {
      if (isStability) {
        if (capacity < 0.01 || capacity > 10) {
          this.formValidation.rciCapacity = true;
          if (!silentCheck) {
            this.formValidation.formErrors.rciForm.rciCapacity = '  ';
            await MessageCenter.addNotificationFromCode('WDT_35');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.rciCapacity = false;
          this.formValidation.formErrors.rciForm.rciCapacity = '';
          this.formValidation.hasError = false;
        }
      }
      else {
        if (stability < 0.01 || stability > 10) {
          this.formValidation.rciStability = true;
          if (!silentCheck) {
            this.formValidation.formErrors.rciForm.rciStability = ' ';
            await MessageCenter.addNotificationFromCode('WDT_34');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.rciStability = false;
          this.formValidation.formErrors.rciForm.rciStability = '';
          this.formValidation.hasError = false;
        }
      }
    }
  }
  @action.bound async validateRciDiff_class(isStability) {
    const stability = this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability;
    const capacity = this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity;
    const bothValidValues = (stability !== '' && capacity !== '');
    if (!bothValidValues) { return };
    // Both values should be valid for this comparison
    // If either is invalid, that takes priority for the user to fix
    // check if both inputs have valid comparison
    if (this.rciMenu[stability] > this.rciMenu[capacity]) {
      // Set both to be invalid
      this.formValidation.retardanceClassForStability = true;
      this.formValidation.formErrors.retardanceClassForm.retardanceClassForStability = ' ';
      this.formValidation.retardanceClassForCapacity = true;
      this.formValidation.formErrors.retardanceClassForm.retardanceClassForCapacity = '  ';
      await MessageCenter.addNotificationFromCode('WDT_13');
      this.formValidation.hasError = true;
    }
    // If neither valid OR both are valid with the right comparison, try to reset the other if valid.
    else {
      if (isStability) {
        if (capacity === '') {
          this.formValidation.retardanceClassForCapacity = true;
          this.formValidation.formErrors.retardanceClassForm.retardanceClassForCapacity = ' ';
          await MessageCenter.addNotificationFromCode('WDT_62');
          this.formValidation.hasError = true;
        } else {
          this.formValidation.retardanceClassForCapacity = false;
          this.formValidation.formErrors.retardanceClassForm.retardanceClassForCapacity = '';
          this.formValidation.hasError = false;
        }
      }
      else {
        if (stability === '') {
          this.formValidation.retardanceClassForStability = true;
          this.formValidation.formErrors.retardanceClassForm.retardanceClassForStability = ' ';
          await MessageCenter.addNotificationFromCode('WDT_62');
          this.formValidation.hasError = true;
        } else {
          this.formValidation.retardanceClassForStability = false;
          this.formValidation.formErrors.retardanceClassForm.retardanceClassForStability = '';
          this.formValidation.hasError = false;
        }
      }
    }
  }

  turnOffHasInputChangedFlag() {
    this.hasAnyInputChanged = false;
  }

  @action.bound async validateInput(name, value, silentCheck?: boolean) {
    let fixed_2 = value;
    let fixed_3 = value;
    let fixed_4 = value;
    this.hasAnyInputChanged = true;



    if (value !== undefined && value !== '') {
      if (name === 'manningStability' || name === 'manningCapacity') {
        fixed_3 = parseFloat(parseFloat(value).toFixed(3));
        fixed_4 = parseFloat(parseFloat(value).toFixed(4));
        this.setFixedValue(name, fixed_4);

      } else if (
        name === 'manualboxTwo' ||
        name === 'rciStability' ||
        name === 'rciCapacity' ||
        name === 'stemLengthStabilityLength' ||
        name === 'stemLengthStabilityDensity' ||
        name === 'stemLengthCapacityLength' ||
        name === 'stemLengthCapacityDensity'
      ) {
        fixed_2 = parseFloat(parseFloat(value).toFixed(2));
        this.setFixedValue(name, fixed_2);
      }
    }

    switch (name) {
      case 'vegetalCoverDropdown':
        if (value === '') {
          this.formValidation.vegetalCoverDropdown = true;
          if (!silentCheck) {
            this.formValidation.formErrors.vegetalCoverDropdown = ' ';
            await MessageCenter.addNotificationFromCode('Common_09', undefined, 'Vegetal Cover Type');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.vegetalCoverDropdown = false;
          this.formValidation.formErrors.vegetalCoverDropdown = '';
          this.formValidation.hasError = false;
        }
        break;

      case 'manualboxOne':
        if (value === '') {
          this.formValidation.manualboxOne = true;
          if (!silentCheck) {
            this.formValidation.formErrors.manualboxOne = ' ';
            if (!this.disableVegetalCoverManualInputs) {
              await MessageCenter.addNotificationFromCode('WDT_37');
            }
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.manualboxOne = false;
          this.formValidation.formErrors.manualboxOne = '';
          this.formValidation.hasError = false;
        }
        break;

      case 'manualboxTwo':
        if (value === '' || fixed_2 < 0.0 || fixed_2 > 1.0) {
          this.formValidation.manualboxTwo = true;
          if (!silentCheck) {
            this.formValidation.formErrors.manualboxTwo = ' ';
            if (!this.disableVegetalCoverManualInputs) {
              await MessageCenter.addNotificationFromCode('WDT_14');
            }
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.manualboxTwo = false;
          this.formValidation.formErrors.manualboxTwo = '';
          this.formValidation.hasError = false;
        }
        break;

      case 'retardanceClassForStability':
        if (value === '') {
          this.formValidation.retardanceClassForStability = true;
          if (!silentCheck) {
            this.formValidation.formErrors.retardanceClassForm.retardanceClassForStability = ' ';
            await MessageCenter.addNotificationFromCode('WDT_62');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.retardanceClassForStability = false;
          this.formValidation.formErrors.retardanceClassForm.retardanceClassForStability = '';
          this.formValidation.hasError = false;
        }
        await this.validateRciDiff_class(true);
        break;

      case 'retardanceClassForCapacity':
        if (value === '') {
          this.formValidation.retardanceClassForCapacity = true;
          if (!silentCheck) {
            this.formValidation.formErrors.retardanceClassForm.retardanceClassForCapacity = ' ';
            await MessageCenter.addNotificationFromCode('WDT_62');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.retardanceClassForCapacity = false;
          this.formValidation.formErrors.retardanceClassForm.retardanceClassForCapacity = '';
          this.formValidation.hasError = false;
        }
        await this.validateRciDiff_class(false);
        break;

      case 'rciStability':
        if ((value === '' || value === undefined) || (fixed_2 < 0.01 || fixed_2 > 10)) {
          this.formValidation.rciStability = true;
          if (!silentCheck) {
            this.formValidation.formErrors.rciForm.rciStability = ' ';
            await MessageCenter.addNotificationFromCode('WDT_34');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.rciStability = false;
          this.formValidation.formErrors.rciForm.rciStability = '';
          this.formValidation.hasError = false;
        }
        await this.validateRciDiff(true, silentCheck);
        break;

      case 'rciCapacity':
        if ((value === '' || value === undefined) || (fixed_2 < 0.01 || fixed_2 > 10)) {
          this.formValidation.rciCapacity = true;
          if (!silentCheck) {
            this.formValidation.formErrors.rciForm.rciCapacity = ' ';
            await MessageCenter.addNotificationFromCode('WDT_35');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.rciCapacity = false;
          this.formValidation.formErrors.rciForm.rciCapacity = '';
          this.formValidation.hasError = false;
        }
        await this.validateRciDiff(false, silentCheck);
        break;

      case 'stemLengthStabilityLength':
        if ((value === '' || value === undefined) || (fixed_2 < 0.01 || fixed_2 > 3.5)) {
          this.formValidation.stemLengthStabilityLength = true;
          if (!silentCheck) {
            this.formValidation.formErrors.stemLengthDensityForm.stemLengthStabilityLength = ' ';
            await MessageCenter.addNotificationFromCode('WDT_15');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.stemLengthStabilityLength = false;
          this.formValidation.formErrors.stemLengthDensityForm.stemLengthStabilityLength = '';
          this.formValidation.hasError = false;
        }
        this.formValidation.formErrors.stemLengthDensityForm.stemCapacityRCI = "";
        this.formValidation.formErrors.stemLengthDensityForm.stemStabilityRCI = "";
        break;

      case 'stemLengthStabilityDensity':
        if ((value === '' || value === undefined) || (fixed_2 < 11 || fixed_2 > 600)) {
          this.formValidation.stemLengthStabilityDensity = true;
          if (!silentCheck) {
            this.formValidation.formErrors.stemLengthDensityForm.stemLengthStabilityDensity = ' ';
            await MessageCenter.addNotificationFromCode('WDT_16');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.stemLengthStabilityDensity = false;
          this.formValidation.formErrors.stemLengthDensityForm.stemLengthStabilityDensity = '';
          this.formValidation.hasError = false;
        }
        this.formValidation.formErrors.stemLengthDensityForm.stemCapacityRCI = "";
        this.formValidation.formErrors.stemLengthDensityForm.stemStabilityRCI = "";
        break;

      case 'stemLengthCapacityLength':
        if ((value === '' || value === undefined) || (fixed_2 < 0.01 || fixed_2 > 3.5)) {
          this.formValidation.stemLengthCapacityLength = true;
          if (!silentCheck) {
            this.formValidation.formErrors.stemLengthDensityForm.stemLengthCapacityLength = ' ';
            await MessageCenter.addNotificationFromCode('WDT_15');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.stemLengthCapacityLength = false;
          this.formValidation.formErrors.stemLengthDensityForm.stemLengthCapacityLength = '';
          this.formValidation.hasError = false;
        }
        this.formValidation.formErrors.stemLengthDensityForm.stemCapacityRCI = "";
        this.formValidation.formErrors.stemLengthDensityForm.stemStabilityRCI = "";
        break;

      case 'stemLengthCapacityDensity':
        if ((value === '' || value === undefined) || (fixed_2 < 11 || fixed_2 > 600)) {
          this.formValidation.stemLengthCapacityDensity = true;
          if (!silentCheck) {
            this.formValidation.formErrors.stemLengthDensityForm.stemLengthCapacityDensity = ' ';
            await MessageCenter.addNotificationFromCode('WDT_16');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.stemLengthCapacityDensity = false;
          this.formValidation.formErrors.stemLengthDensityForm.stemLengthCapacityDensity = '';
          this.formValidation.hasError = false;
        }
        this.formValidation.formErrors.stemLengthDensityForm.stemCapacityRCI = "";
        this.formValidation.formErrors.stemLengthDensityForm.stemStabilityRCI = "";
        break;

      case 'calculatedStabilityRci':
      case 'calculatedCapacityRci':
        if (
          value === 0 ||
          this.defineVegetalCoverForm.stemLengthDensityForm.stemStabilityRci >
          this.defineVegetalCoverForm.stemLengthDensityForm.stemCapacityRci
        ) {
          if (!silentCheck) {
            await MessageCenter.addNotificationFromCode('WDT_13');
            this.formValidation.formErrors.stemLengthDensityForm.stemStabilityRCI = ' ';
            this.formValidation.formErrors.stemLengthDensityForm.stemCapacityRCI = ' ';
          }
          this.formValidation.hasError = true;
          this.formValidation.stemStabilityRci = true;
          this.formValidation.stemCapacityRci = true;
        } else {
          this.formValidation.formErrors.stemLengthDensityForm.stemStabilityRCI = '';
          this.formValidation.formErrors.stemLengthDensityForm.stemCapacityRCI = '';
          this.formValidation.hasError = false;
          this.formValidation.stemStabilityRci = false;
          this.formValidation.stemCapacityRci = false;
        }
        break;

      case 'manningStability':
        if ((value === '' || value === undefined) || (fixed_4 < 0.0001 || fixed_4 > 1.0000)) { //||.15)) {
          this.formValidation.manningStability = true;
          if (!silentCheck) {
            this.formValidation.formErrors.manningForm.manningStability = ' ';
            await MessageCenter.addNotificationFromCode('Formula_02');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.manningStability = false;
          this.formValidation.formErrors.manningForm.manningStability = '';
          this.formValidation.hasError = false;
        }
        break;

      case 'manningCapacity':
        if ((value === '' || value === undefined) || (fixed_4 < 0.0001 || fixed_4 > 1.0000)) { //||.15)) {
          this.formValidation.manningCapacity = true;
          if (!silentCheck) {
            this.formValidation.formErrors.manningForm.manningCapacity = ' ';
            await MessageCenter.addNotificationFromCode('Formula_02');
          }
          this.formValidation.hasError = true;
        } else {
          this.formValidation.manningCapacity = false;
          this.formValidation.formErrors.manningForm.manningCapacity = '';
          this.formValidation.hasError = false;
        }
        break;
    }
  }



  @action.bound async handleVegetalCoverDropdownInputChange(event) {
    const { name, value } = event.target;
    this.defineVegetalCoverForm[name] = value;
    terraceDesignStore.terraceInputsChanged = true
    this.hasAnyInputChanged = true;
    if (value === '') {
      this.formValidation.vegetalCoverDropdown = true;
      this.formValidation.formErrors.vegetalCoverDropdown = ' ';
      this.formValidation.hasError = true;
    }
    else {
      this.formValidation.vegetalCoverDropdown = false;
      this.formValidation.formErrors.vegetalCoverDropdown = '';
      this.formValidation.hasError = false;
    }

    if (value.toLocaleLowerCase() === 'manual entry') {
      this.disableVegetalCoverManualInputs = false;
    } else {
      this.disableVegetalCoverManualInputs = true;
      this.defineVegetalCoverForm.manualboxOne = '';
      this.defineVegetalCoverForm.manualboxTwo = '';
      this.dropdownErrorClassOne('manualboxOne');
      this.dropdownErrorClassTwo('manualboxTwo');
    }
  }

  //api call to receive vegetal cover params
  @action.bound async getVegetalParameters() {
    try {
      const response: any = await ParameterController.getDefaultParameterByIdUsingGET(2);
      if (response.data) {
        const value = JSON.parse(response.data.json);
        if (this.mode === 'adminGlobalPreferences') { value.coverFactors.splice(value.coverFactors.findIndex(item => item.label === "MANUAL_ENTRY"), 1) }
        this.vegetalCoverOptions = value.coverFactors.map((x) => {
          if (x.label === 'MANUAL_ENTRY') {
            return {
              name: x.description,
              value: x.description,
            };
          }
          return {
            name: x.description + ' (' + x.factor + ')',
            value: x.description + ' (' + x.factor + ')',
          };
        });
        this.retardanceClassMenu = value.retardClasses.map((item) => {
          return { name: item.retardanceClass, value: item.retardanceClass };
        });
        value.retardClasses.forEach(element => {
          this.rciMenu[element.retardanceClass] = element.rci;
        });
      }
    } catch (error) {
      console.error(' error: get waterway sizing calculator API error', error);
    } finally {
      if (this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity !== '') {
        // class provided
        if (this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity.split('(')[1]) {
          this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity = this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity.split('(')[1].slice(0, -1);
          this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability = this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability.split('(')[1].slice(0, -1);
        }
        // no class provided - number only
        else {
          const temp = Object.keys(this.rciMenu).find(key => this.rciMenu[key] === parseFloat(this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity));
          if (temp === undefined) {
            this.RetardanceClassControl = 1;
            this.defineVegetalCoverForm.rciForm.rciCapacity = parseFloat(this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity);
            this.defineVegetalCoverForm.rciForm.rciStability = parseFloat(this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability);
          }
          else {
            this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity = Object.keys(this.rciMenu).find(key => this.rciMenu[key] === parseFloat(this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity))!;
            this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability = Object.keys(this.rciMenu).find(key => this.rciMenu[key] === parseFloat(this.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability))!;
          }
        }
      }
    }
  }

  @action.bound async calculateStabilityRci() {
    this.rciStabilityCalculated = false;
    if (!this.formValidation.stemLengthStabilityDensity &&
      !this.formValidation.stemLengthStabilityLength) {
      const length = this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityLength;
      const density = this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityDensity;
      if (length && density && length !== "RESET" && density !== "RESET") {
        const rci = await this.calcVegetalCoverRCI(length, density);
        this.defineVegetalCoverForm.stemLengthDensityForm.stemStabilityRci = parseFloat(rci.toFixed(2));
        this.rciStabilityCalculated = true;
        if (this.defineVegetalCoverForm.stemLengthDensityForm.stemStabilityRci > this.defineVegetalCoverForm.stemLengthDensityForm.stemCapacityRci && this.defineVegetalCoverForm.stemLengthDensityForm.stemStabilityRci !== 0 && this.defineVegetalCoverForm.stemLengthDensityForm.stemCapacityRci !== 0) {
          await MessageCenter.addNotificationFromCode('WDT_13');
          this.formValidation.formErrors.stemLengthDensityForm.stemStabilityRCI = " "
          this.formValidation.formErrors.stemLengthDensityForm.stemCapacityRCI = " "
        }
      }
    }
  }
  @action.bound async calculateCapacityRci() {
    this.rciCapacityCalculated = false
    if (!this.formValidation.stemLengthCapacityDensity &&
      !this.formValidation.stemLengthCapacityLength) {
      const length = this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityLength;
      const density = this.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityDensity;
      if (length && density && length !== "RESET" && density !== "RESET") {
        const rci = await this.calcVegetalCoverRCI(length, density);
        this.defineVegetalCoverForm.stemLengthDensityForm.stemCapacityRci = parseFloat(rci.toFixed(2));
        this.rciCapacityCalculated = true
        if (this.defineVegetalCoverForm.stemLengthDensityForm.stemStabilityRci > this.defineVegetalCoverForm.stemLengthDensityForm.stemCapacityRci && this.defineVegetalCoverForm.stemLengthDensityForm.stemStabilityRci !== 0 && this.defineVegetalCoverForm.stemLengthDensityForm.stemCapacityRci !== 0) {
          await MessageCenter.addNotificationFromCode('WDT_13');
          this.formValidation.formErrors.stemLengthDensityForm.stemCapacityRCI = " ";
          this.formValidation.formErrors.stemLengthDensityForm.stemStabilityRCI = " ";
        }
      }
    }
  }
  @action.bound async calcVegetalCoverRCI(length, density): Promise<number> {
    const params = {
      stabStemDensity: +density,
      stabStemLength: +length,
    };
    try {
      const response: any = await WaterwaySizingController.calVegetalCoverStabilityRCIUsingPOST(params);
      if (response.data.stabilityRCI) {
        return response.data.stabilityRCI;
      }
    } catch (err) {
      MessageCenter.addError((err as Error).message);
    }
    return 0;
  }
}
